import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { auth } from "../firebase/firebase";
import { doc, deleteDoc, getDoc, setDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { saveUserText, getUserText } from "../firebase/dbServices";
import { db } from "../firebase/firebase"; // Adjust this path to where your Firebase config is located


import { toast } from 'react-toastify';
import BarLoader from 'react-spinners/BarLoader';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { IoCheckmarkDoneSharp, IoClose } from "react-icons/io5";
import NavLogin from "../components/NavLogin";
import { MdDownloadDone, MdOutlineHome } from "react-icons/md";
import { RiSave3Line } from "react-icons/ri";
import { LuImagePlus } from "react-icons/lu";
import Ptn from "../components/Ptn";
import placeholderImage from '../assets/img/placeholderImage.webp'




const LegalUpdateEditor = ({ isScrolled }) => {
    const [title, setTitle] = useState("");
    const [text, setText] = useState("");
    const [image, setImage] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [imageURL, setImageURL] = useState("");
    const [loading, setLoading] = useState(false);
    const [showHome, setShowHome] = useState(false);
    const [saved, setSaved] = useState(false);

    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/"); // Navigate to homepage

        setTimeout(() => {
            const homeSection = document.getElementById("home");
            if (homeSection) {
                const offset = 20; // Adjust scroll offset
                const targetY = homeSection.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({ top: targetY, behavior: "smooth" });
            }
        }, 100); // Delay ensures the page loads before scrolling
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if (!currentUser) {
                navigate("/login"); // Redirect to login if not signed in
            } else {
                fetchUserText(currentUser.uid); // Fetch the saved text and title
            }
        });

        return () => unsubscribe();
    }, []);

    const fetchUserText = async (uid) => {
        const userText = await getUserText(uid);
        if (userText) {
            setTitle(userText.title);
            setText(userText.text);
            setImageURL(userText.imageURL || ""); // Fetch saved image URL
        }
    };

    const [fileName, setFileName] = useState("No file chosen");

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
            resizeImage(file, 1200); // Resize image to at least 1200px wide
        }
    };

    const resizeImage = (file, minWidth) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const aspectRatio = img.height / img.width;
                const newWidth = minWidth;
                const newHeight = newWidth * aspectRatio;

                // Create a canvas
                const canvas = document.createElement("canvas");
                canvas.width = newWidth;
                canvas.height = newHeight;
                const ctx = canvas.getContext("2d");

                // Draw the resized image
                ctx.drawImage(img, 0, 0, newWidth, newHeight);

                // Convert canvas back to a Data URL
                const resizedImageURL = canvas.toDataURL("image/jpeg", 0.9);
                setImageURL(resizedImageURL);
            };
        };
    };

    const handleRemoveImage = () => {
        setImageURL(null);
        setFileName("Select File");
    };


    const handleSave = async () => {
        setLoading(true);
        setSaved(false); // Reset saved state when saving starts
        setShowHome(false)
        const user = auth.currentUser;
        if (!user) return alert("Sign in first!");

        try {
            const docRef = doc(db, "userTexts", user.uid);

            // Upload image if selected
            let uploadedImageURL = imageURL;
            if (image) {
                const storage = getStorage();
                const storageRef = ref(storage, `userImages/${user.uid}/${image.name}`);
                const uploadTask = uploadBytesResumable(storageRef, image);

                await new Promise((resolve, reject) => {
                    uploadTask.on(
                        "state_changed",
                        null,
                        (error) => reject(error),
                        async () => {
                            uploadedImageURL = await getDownloadURL(uploadTask.snapshot.ref);
                            setImageURL(uploadedImageURL);
                            resolve();
                        }
                    );
                });
            }

            await setDoc(docRef, {
                title: title || "",
                text: text || "",
                imageURL: uploadedImageURL,
            });

            fetchUserText(user.uid);
            setShowHome(true);
            setLoading(false);
            setSaved(true); // Set saved state to true
            setTimeout(() => setSaved(false), 12000); // Reset after 12 seconds
            toast.success(
                <>
                    <h5 className={`relative btnTxtSize text-center xsm:text-[0.7rem] sm:text-[0.725rem] xl:text-[0.75rem] 2xl:text-[0.8rem]`}>
                        Legal Bugle Updated
                    </h5>
                </>,
                {
                    position: 'bottom-center',
                    closeButton: false,
                    autoClose: 8000,
                    /* icon: <MdDownloadDone className='absolute left-0 text-white xsm:text-[1rem] sm:text-[1.15rem] xl:text-[1.25rem] 2xl:text-[1.5rem]' /> */
                }
            );
        } catch (error) {
            console.error("Error saving:", error);
            console.log(`Failed to save: ${error.message || "Unknown error"}`);
            setLoading(false);
            toast.error(
                <>
                    <h5 className={`relative btnTxtSize text-center xsm:text-[0.7rem] sm:text-[0.725rem] xl:text-[0.75rem] 2xl:text-[0.8rem]`}>
                        Legal Bugle Update Failed
                    </h5>
                </>,
                {
                    position: 'bottom-center',
                    closeButton: false,
                    autoClose: 8000,
                    /* icon: <MdDownloadDone className='absolute left-0 text-white xsm:text-[1rem] sm:text-[1.15rem] xl:text-[1.25rem] 2xl:text-[1.5rem]' /> */
                }
            );
        }
    };

    const fadeIn = {
        initial: {
            opacity: 0,
            y: 30
        },
        animate: {
            opacity: 1,
            y: 0,
            transition: {
                ease: "easeInOut",
                duration: 0.35,
                delay: 1
            }
        },
        exit: {
            opacity: 0,
            y: 30,
            transition: {
                ease: "easeInOut",
                duration: 0.75
            }
        },
    };


    return (
        <AnimatePresence>
            <motion.div
                variants={fadeIn}
                initial="initial"
                animate="animate"
                exit="exit"
            >
                <section
                    id="legal_editor"
                >
                    <div
                        className="relative z-[800]"
                    >
                        <NavLogin
                            isScrolled={isScrolled}
                        />
                    </div>
                    <div className="flex flex-col items-center justify-center xs:pt-[5rem] xsp:pt-[6rem] md:pt-[7rem] lg:pt-[6rem] 2xl:pt-[8rem] lg:w-[92.5%] xl:w-[90%] 2xl:w-[85%] 4xl:w-[77.5%] mx-auto">
                        <div className="fixed top-0 left-0 xs:bg-gradient-to-t lg:bg-gradient-to-r from-bgSky via-bgSky to-bgSky/0 xs:w-full lg:w-[75%] h-full z-20" />
                        <Ptn
                            isScrolled={isScrolled}
                        />
                        {/* <div className={`xs:hidden lg:block fixed top-0 left-0 bgPtn w-full h-screen z-[100] mix-blend-multiply`} /> */}
                        <div
                            className="xs:w-[95%] xsp:w-[90%] md:w-[85%] lg:w-[85%] 2xl:w-[80%] flex flex-col items-start justify-center z-[200]"
                        >
                            <h6
                                className="playfair introTitle introTitleTxtSize mb-[2rem] text-[1.5rem] !text-center w-full py-[1rem] border-b border-slate-600/20"
                            >
                                Update the legal bugle section
                            </h6>
                            <div
                                className="bg-white/70 w-full glsOutline border-[3px] border-white xs:px-[1rem] md:px-[2rem] lg:px-[2rem] xl:px-[2rem] 2xl:px-[2rem] xs:py-[1rem] lg:py-[2rem] xs:rounded-[16px] lg:rounded-[24px] shadow-2xl mb-[1rem]"
                            >
                                <input
                                    type="text"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Enter Title"
                                    className="border p-[1rem] w-full mb-[1rem] rounded-[4px] outfit border-slate-600/30 bg-white/90 btnTxtSize"
                                />
                                <textarea
                                    value={text}
                                    onChange={(e) => setText(e.target.value)}
                                    className="border p-[1rem] w-full xs:h-[20rem] 2xl:h-[28rem] rounded-[6px] border-slate-600/30 outfit text-slate-800 bg-white/90 resize-none overflow-y-scroll xs:max-h-[20rem] lg:max-h-[24rem] 2xl:max-h-[30rem] btnTxtSize"
                                    placeholder="Write your text here"
                                />
                                <div className="w-full flex flex-col items-center justify-center">
                                    <p className="xs:mt-[1rem] lg:mt-[1rem] outfit text-slate-600 btnTxtSize">
                                        Select Image (if necessary):
                                    </p>
                                    <div className="flex flex-col items-start justify-center mt-[0.5rem] btnTxtSize">
                                        <label className="alata group trns500 border text-center py-[0.5rem] w-full mb-2 rounded-[4px] border-slate-600/30 bg-white/90 hover:bg-slate-800 text-slate-700 hover:text-white cursor-pointer capitalize xs:min-w-[200px] md:min-w-[250px] 2xl:min-w-[300px]">
                                            <div
                                                className="relative flex items-center justify-center"
                                            >
                                                <p className="xs:max-w-[9rem] lg:max-w-[10rem] 2xl:max-w-[13rem] overflow-hidden whitespace-nowrap">
                                                    {imageURL ? "Replace Current Image" : fileName || "No file chosen"}
                                                </p>
                                                <LuImagePlus className="trns500 absolute right-[8px] text-slate-500 group-hover:text-white xs:text-[0.9rem] lg:text-[1rem] 2xl:text-[1.15rem]" />
                                            </div>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                                className="hidden"
                                            />
                                        </label>

                                        {imageURL && (
                                            <div
                                                className="w-full flex items-center justify-center"
                                            >
                                                <div className="relative xs:mt-[0.5rem] lg:mt-[1rem] xs:mb-[1rem] lg:mb-0">
                                                    <img
                                                        src={imageURL}
                                                        alt="Uploaded Preview"
                                                        className="xs:w-[200px] md:w-[250px] 2xl:w-[300px] h-auto object-cover border-[2px] rounded-md border-white shadow-2xl"
                                                    />
                                                    <button
                                                        onClick={handleRemoveImage}
                                                        className="trns500 cursor-pointer absolute -top-[0.75rem] -right-[0.75rem] bg-red-700 text-white text-xs rounded-full p-2 hover:bg-red-900 border-[3px] border-white outline-[4px] outline-offset-[1px] outline-red-700/0 hover:outline-red-900 shadow-md"
                                                    >
                                                        <IoClose className="text-[1.25rem]" />
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>


                            <p className="text-slate-500/80 outfit font-[700] xs:mt-[1.5rem] xsp:mt-[2rem] md:mt-[3rem] lg:mt-[2.5rem] uppercase tracking-[4px] xs:pb-[1rem] lg:pb-[1.25rem] 2xl:pb-[1.5rem] w-full text-center xs:text-[0.6rem] xsp:text-[0.7rem] md:text-[0.75rem] lg:text-[0.65rem] xl:text-[0.7rem] 2xl:text-[0.8rem]">
                                Preview
                            </p>
                            <div
                                className="bg-white/70 border-[3px] border-white xs:rounded-[16px] lg:rounded-[24px] xs:px-[1rem] md:px-[1.5rem] lg:px-[2rem] 2xl:px-[2rem] mb-[2rem] shadow-2xl glsOutline"
                            >
                                {title && (
                                    <h6 className='outfit w-full xs:text-[0.725rem] md:text-[0.95rem] lg:text-[0.75rem] xl:text-[0.8rem] 2xl:text-[0.95rem] xs:mt-[1rem] lg:mt-[1.5rem] uppercase font-[700] tracking-[1px] xs:pb-[0.5rem] lg:pb-[1rem] border-b border-slate-600/20 text-slate-500'>
                                        {title}
                                    </h6>
                                )}
                                <div className="flex xs:flex-col lg:flex-row gap-x-[2rem] my-[1rem]">
                                    {/* Image Container */}
                                    <div className="flex-[2]">
                                        {imageURL ? (
                                            <div className="relative border border-slate-600/50 rounded-md overflow-hidden lg:mt-[1rem]">
                                                <img
                                                    src={imageURL}
                                                    alt="Uploaded Preview"
                                                    className="w-full h-full object-cover object-center"
                                                />
                                            </div>
                                        ) : (
                                            <div className="relative border border-slate-600/50 rounded-md overflow-hidden lg:mt-[1rem]">
                                                <img
                                                    src={placeholderImage}
                                                    alt="Uploaded Preview"
                                                    className="w-full h-full object-cover object-center"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {/* Text Container */}
                                    <div className="flex-[3] px-[0.5rem]">
                                        <p className="text-slate-600 outfit xs:mt-[0.5rem] lg:mt-[0rem] mb-[1rem] text-justify bodyTxt">
                                            {text &&
                                                text.split("\n").map((paragraph, index) => (
                                                    <p
                                                        key={index}
                                                    >
                                                        <br />
                                                        {paragraph}
                                                    </p>
                                                ))
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="flex flex-row xs:gap-x-[1rem] lg:gap-x-[3rem] 2xl:gap-x-[4rem] w-full items-center justify-center mt-[1rem]"
                            >
                                <button
                                    onClick={handleSave}
                                    className={`trns500 group relative z-[200] cursor-pointer flex items-center justify-center alata btnTxtSize tracking-[0px] text-white/90 hover:text-black xs:w-[45%] md:w-[12rem] lg:w-[10rem] xl:w-[12rem] 2xl:w-[14rem] xs:h-[3.25rem] xsp:h-[3.5rem] lg:h-[3rem] xl:h-[3.5rem] 2xl:h-[4rem] rounded-full xs:border-[3px] 2xl:border-[4px] border-slate-200/95 hover:border-slate-200 shadow-2xl xs:outline-[3px] 2xl:outline-[4px] outline-white/80 hover:outline-slate-900/80 btnTxtShadow ${saved ? 'bg-gradient-to-r from-lime-600 to-lime-500' : 'bg-gradient-to-r from-primaryRichBlue to-primaryRichGreen'}`}
                                >
                                    {loading ? (
                                        <BarLoader height={2} width={60} color="#fff" />
                                    ) : saved ? (
                                        <>
                                            Saved
                                            <IoCheckmarkDoneSharp className='trns500 absolute bg-white/20 group-hover:bg-slate-900 border-[2px] border-white/20 group-hover:border-slate-900/0 group-hover:text-white rounded-full xs:p-[0.45rem] lg:p-[0.6rem] xl:p-[0.7rem] xs:h-[2.25rem] xs:w-[2.25rem] md:h-[2.5rem] md:w-[2.5rem] lg:h-[2.25rem] lg:w-[2.25rem] xl:h-[2.5rem] xl:w-[2.5rem] 2xl:h-[2.75rem] 2xl:w-[2.75rem] xs:right-[0.3rem] md:right-[0.5rem] lg:right-[0.4rem] xl:right-[0.4rem] shadow-md' />
                                        </>
                                    ) : (
                                        <>
                                            Save
                                            <RiSave3Line className={`trns500 absolute bg-white/20 group-hover:bg-slate-900 border-[2px] border-white/20 group-hover:border-slate-900/0 group-hover:text-white rounded-full xs:p-[0.55rem] lg:p-[0.6rem] xl:p-[0.7rem] xs:h-[2.25rem] xs:w-[2.25rem] md:h-[2.5rem] md:w-[2.5rem] lg:h-[2.75rem] lg:w-[2.75rem] xl:h-[2.5rem] xl:w-[2.5rem] 2xl:h-[2.75rem] 2xl:w-[2.75rem] xs:right-[0.3rem] md:right-[0.5rem] lg:right-[0.4rem] xl:right-[0.4rem] shadow-md ${loading ? 'hidden' : 'block'}`} />
                                        </>
                                    )}
                                </button>
                                {showHome && (
                                    <button
                                        // onClick={() => navigate("/")}
                                        onClick={handleClick}
                                        className="bg-gradient-to-r from-teal-700 via-teal-600 to-teal-400 trns500 group relative z-[200] cursor-pointer flex items-center justify-center alata btnTxtSize tracking-[0px] text-white/90 hover:text-black xs:w-[45%] md:w-[12rem] lg:w-[10rem] xl:w-[12rem] 2xl:w-[14rem] xs:h-[3.25rem] xsp:h-[3.5rem] lg:h-[3rem] xl:h-[3.5rem] 2xl:h-[4rem] rounded-full xs:border-[3px] 2xl:border-[4px] border-slate-200/95 hover:border-slate-200 shadow-2xl xs:outline-[3px] 2xl:outline-[4px] outline-white/80 hover:outline-slate-900/80 btnTxtShadow"
                                    >
                                        Home
                                        <MdOutlineHome className='trns500 absolute bg-white/20 group-hover:bg-slate-900 border-[2px] border-white/20 group-hover:border-slate-900/0 group-hover:text-white rounded-full xs:p-[0.45rem] lg:p-[0.6rem] xl:p-[0.6rem] xs:h-[2.25rem] xs:w-[2.25rem] md:h-[2.5rem] md:w-[2.5rem] lg:h-[2.25rem] lg:w-[2.25rem] xl:h-[2.5rem] xl:w-[2.5rem] 2xl:h-[2.75rem] 2xl:w-[2.75rem] xs:right-[0.3rem] md:right-[0.5rem] lg:right-[0.4rem] xl:right-[0.4rem] shadow-md' />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </motion.div>
        </AnimatePresence>
    );
};

export default LegalUpdateEditor;
